import { render, staticRenderFns } from "./ClaioContentsTreeSelector.vue?vue&type=template&id=36d25561&scoped=true&"
import script from "./ClaioContentsTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./ClaioContentsTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioContentsTreeSelector.vue?vue&type=style&index=0&id=36d25561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d25561",
  null
  
)

export default component.exports